import Buttons from "../../../components/Buttons/Buttons";
import TextInput from "../../../components/TextInput/TextInput";
import SelectInput from "../../../components/SelectInput/SelectInput";
import HeightInput from "../../../components/heightInput/HeightInput";
import DateInput from "../../../components/DateInput/DateInput";
import AcquisitionSettingsFields from "./AcquisitionSettingsFields";

const wOptions = [
  { value: "1", label: "kg" },
  { value: "2", label: "pound" },
];

const hOptions = [
  { value: "1", label: "feet" },
  { value: "2", label: "cm" },
];

const PatientFormFields = ({
  formData,
  errors,
  gender,
  device,
  data,
  isEditing,
  resetPassword,
  onChange,
  onCheckboxChange,
  onRemoveDevice,
  onDeviceSelect,
  onResetPasswordClick,
  showAcquisitionSettings = true,
}) => {
  return (
    <div className="patientdetails_container_section">
      {/* Identity */}
      <div className="patientdetails_container_section_input">
        <TextInput
          title="Name*"
          type="text"
          name="name"
          value={formData.name}
          onChange={onChange}
          placeholder="Enter Name"
        />
        <span className="error">{errors.name}</span>
      </div>
      <div className="patientdetails_container_section_input">
        <TextInput
          title="User Name*"
          type="text"
          name="userName"
          value={formData.userName}
          onChange={onChange}
          placeholder="Enter User Name"
        />
        <span className="error">{errors.userName}</span>
      </div>
      <div className="patientdetails_container_section_input">
        {isEditing ? (
          <div className="password-row">
            <TextInput
              title="Password*"
              type="password"
              name="password"
              value={resetPassword ? formData.password : "********"}
              onChange={onChange}
              placeholder={
                resetPassword ? "Enter new password" : "Enter Password"
              }
              disabled={!resetPassword}
            />
            <Buttons
              text={resetPassword ? "Cancel" : "Reset"}
              type="button"
              variant={resetPassword ? "smallsecondary" : "smallprimary"}
              onClick={onResetPasswordClick}
              style={{ height: "40px" }}
            />
          </div>
        ) : (
          <TextInput
            title="Password*"
            type="text"
            name="password"
            value={formData.password}
            onChange={onChange}
            placeholder="Enter Password"
          />
        )}
      </div>

      {/* Device assignment */}
      {!data ? (
        <div className="patientdetails_container_section_input">
          <SelectInput
            title="Device ID*"
            name="deviceId"
            placeholder="Select Device ID"
            value={formData.deviceId || ""}
            onChange={onChange}
            options={device}
          />
          <span className="error">{errors.deviceId}</span>
        </div>
      ) : formData.deviceId ? (
        <div className="patientdetails_container_section_input device-row">
          <TextInput
            title="Device ID"
            name="deviceId"
            type="text"
            value={formData.deviceName || "No device assigned"}
            onChange={onChange}
            placeholder="Enter Device ID"
            disabled
          />
          <Buttons
            text="Remove"
            type="button"
            variant="smallprimary"
            onClick={onRemoveDevice}
            style={{ height: "40px" }}
          />
        </div>
      ) : (
        // Edit Mode: No device assigned – show dropdown
        <div className="patientdetails_container_section_input">
          <SelectInput
            title="Assign Device ID"
            name="deviceId"
            placeholder="Select Device ID"
            value={formData.deviceId || ""}
            onChange={onDeviceSelect}
            options={device}
          />
          <span className="error">{errors.deviceId}</span>
        </div>
      )}

      {/* Demographics */}
      <div className="patientdetails_container_section_input">
        <SelectInput
          title="Gender"
          name="genderId"
          placeholder="Select Gender"
          value={formData.genderId}
          onChange={onChange}
          options={gender}
        />
        <span className="error">{errors.genderId}</span>
      </div>
      <div className="patientdetails_container_section_input">
        <DateInput
          title="Date of Birth"
          name="dateOfBirth"
          value={formData.dateOfBirth}
          onChange={onChange}
          placeholder="DD-MM-YYYY"
        />
        <span className="error">{errors.dateOfBirth}</span>
      </div>

      {/* Physical stats */}
      <div className="patientdetails_container_section_input">
        <HeightInput
          type="text"
          name="weight"
          title="Weight (kg/pound)"
          value={formData.weight}
          onChange={onChange}
          unit={formData.weightMeasurementType}
          onUnitChange={(e) =>
            onChange({
              target: { name: "weightMeasurementType", value: e.target.value },
            })
          }
          placeholder="Enter weight"
          options={wOptions}
        />
        <span className="error">{errors.weight}</span>
      </div>
      <div className="patientdetails_container_section_input">
        <HeightInput
          type="text"
          name="height"
          title="Height (feet/cm)"
          value={formData.height}
          onChange={onChange}
          unit={formData.heightMeasurementType}
          onUnitChange={(e) =>
            onChange({
              target: { name: "heightMeasurementType", value: e.target.value },
            })
          }
          placeholder="Enter height"
          options={hOptions}
        />
        <span className="error">{errors.height}</span>
      </div>

      {/* Contact */}
      <div className="patientdetails_container_section_input">
        <TextInput
          title="Mobile Number"
          type="tel"
          name="mobileNumber"
          value={formData.mobileNumber}
          onChange={onChange}
          placeholder="Enter Mobile Number"
          maxLength={16}
        />
        <span className="error">{errors.mobileNumber}</span>
      </div>
      <div className="patientdetails_container_section_input">
        <TextInput
          title="Email ID (Optional)"
          type="email"
          name="email"
          value={formData.email}
          onChange={onChange}
          placeholder="Enter Email"
        />
        <span className="error">{errors.email}</span>
      </div>

      {showAcquisitionSettings && (
        <AcquisitionSettingsFields
          formData={formData}
          onChange={onChange}
          onCheckboxChange={onCheckboxChange}
        />
      )}
    </div>
  );
};

export default PatientFormFields;
